/** Placeholder names the projections return for a redacted talent profile. */
const FORMER_USER_FIRSTNAME = "Osaaja";
const FORMER_USER_LASTNAME = "Poistettu";

export function isFormerUser(talent: {
  firstName?: string;
  lastName?: string;
}): boolean {
  return (
    talent.firstName === FORMER_USER_FIRSTNAME &&
    talent.lastName === FORMER_USER_LASTNAME
  );
}
